import GrowCommunityContainer from "../../Containers/GrowCommunity";

const GrowCommunity = () => <GrowCommunityContainer />;

export default GrowCommunity;
